export default __webpack_public_path__ + "static/media/mode_lesson.9d137322.svg";